var map = {
	"./close_icon.png": 169,
	"./complete_icon.png": 28,
	"./guide1.png": 170,
	"./guide2.png": 171,
	"./guide3.png": 172,
	"./icon_close.png": 27,
	"./icon_next.svg": 176,
	"./icon_prev.svg": 175,
	"./left_icon.png": 252,
	"./logo.png": 168,
	"./off_icon.svg": 174,
	"./on_icon.svg": 173,
	"./step_icon.png": 8,
	"./test.jpg": 253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 251;